import { WhatsAppTemplate } from "../models/whatsapp.model";

type TemplateLike = Partial<WhatsAppTemplate> & Record<string, any>;

type TemplateComponentLike = {
  type?: string | null;
  format?: string | null;
  text?: string | null;
  parameters?: Array<{ type?: string | null }>;
};

const MEDIA_HEADER_TYPES = new Set(["IMAGE", "VIDEO", "DOCUMENT"]);

function normalizeText(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

function normalizeUpper(value: unknown): string {
  return normalizeText(value).toUpperCase();
}

function getHeaderComponent(template: TemplateLike): TemplateComponentLike | null {
  const components = Array.isArray(template?.components) ? template.components : [];

  for (const component of components) {
    if (normalizeUpper(component?.type) === "HEADER") {
      return component;
    }
  }

  return null;
}

export function getTemplateHeaderType(template: TemplateLike | null | undefined): string {
  if (!template) {
    return "";
  }

  const directHeaderType = normalizeUpper(template?.header?.type);
  if (directHeaderType) {
    return directHeaderType;
  }

  const headerComponent = getHeaderComponent(template);
  const componentFormat = normalizeUpper(headerComponent?.format);
  if (componentFormat) {
    return componentFormat;
  }

  const parameterType = normalizeUpper(headerComponent?.parameters?.[0]?.type);
  if (parameterType) {
    return parameterType;
  }

  return "";
}

export function getTemplateHeaderContent(template: TemplateLike | null | undefined): string {
  if (!template) {
    return "";
  }

  return (
    normalizeText(template?.header?.content) ||
    normalizeText(getHeaderComponent(template)?.text)
  );
}

export function templateHasMediaHeader(template: TemplateLike | null | undefined): boolean {
  return MEDIA_HEADER_TYPES.has(getTemplateHeaderType(template));
}

export function getTemplateBodyVariableNames(template: TemplateLike | null | undefined): string[] {
  if (!template) return [];
  const components = Array.isArray(template.components) ? template.components : [];
  const bodyComponent = components.find(
    (component: any) => normalizeUpper(component?.type) === "BODY",
  );
  const bodyText = normalizeText(template.body) || normalizeText(bodyComponent?.text);
  const names: string[] = [];
  const pattern = /{{\s*([^{}]+?)\s*}}/g;
  let match: RegExpExecArray | null;
  while ((match = pattern.exec(bodyText)) !== null) {
    const name = match[1].trim();
    if (name && !names.includes(name)) names.push(name);
  }
  return names;
}
